import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { paths } from '@/app/paths';
import { Card, Icon, Pill } from '@/design-system';
import { useGlobalActions } from '@/shell/globalActions';
import { LoadError } from '@/shell/LoadError';
import { websitesQuery } from './api';
import { STATUS_TONE } from './status';
import { useVariantLabel } from './useVariantLabel';
import s from './sites.module.css';

/** The organization's Сайты tab: site cards with a mini wireframe, and the dashed «Создать сайт» card. */
export function OrgSitesTab() {
  const { orgId = '' } = useParams();
  const { t } = useTranslation('sites');
  const { t: to } = useTranslation('organizations');
  const { t: tc } = useTranslation('common');
  const navigate = useNavigate();
  const { openCreateSite } = useGlobalActions();
  const variant = useVariantLabel();
  const q = useQuery(websitesQuery(orgId));
  if (q.isError) return <LoadError error={q.error} onRetry={() => void q.refetch()} />;
  if (!q.data) return null;
  return (
    <div className={s.cards}>
      {q.data.map((x) => (
        <Card key={x.id} padding={0} lift className={s.card} onClick={() => navigate(paths.site(x.id))} aria-label={x.name}>
          <div className={s.wire} aria-hidden>
            <div className={s.wireTop}>
              <div className={s.wireLogo} />
              <div className={s.wireNav}>
                <div className={s.wireNavItem} />
                <div className={s.wireNavItem} />
              </div>
            </div>
            <div className={s.wireBody}>
              <div className={s.wireText}>
                <div className={`${s.wireLine} ${s.w90}`} />
                <div className={`${s.wireLine} ${s.w70}`} />
                <div className={s.wireBtn} />
              </div>
              <div className={s.wireImage} />
            </div>
          </div>
          <div className={s.cardBody}>
            <div className={s.cardRow}>
              <span className={s.cardName}>{x.name}</span>
              <span className={s.cardType}>{t(`type.${x.type}`)}</span>
            </div>
            <span className={s.cardDomain}>{x.domain ?? tc('dash')}</span>
            <div className={s.cardFoot}>
              <Pill tone={STATUS_TONE[x.status]}>{t(`status.${x.status}`)}</Pill>
              <span className={s.cardVariant}>{variant(x)}</span>
            </div>
          </div>
        </Card>
      ))}
      <button type="button" className={s.create} onClick={() => openCreateSite(orgId)}>
        <Icon name="plus" size={22} className={s.createIcon} />
        {to('sites.create')}
        <span className={s.createRule}>{to('sites.create_rule')}</span>
      </button>
    </div>
  );
}
